import {
	ChangeDetectorRef,
	Component,
	HostListener,
	OnInit,
	TemplateRef
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie-service';
import { OptimNotification } from 'src/app/shared/models/optim-notification';
import { FacadeService } from '../../services/facade.service';
import { Notification } from 'src/app/shared/models/notification';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { User } from 'src/app/shared/models/security/user';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Service } from 'src/app/shared/models/service';
import { Region } from 'src/app/shared/models/region';

@Component({
	selector: 'app-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
	modalRef?: BsModalRef;

	// Suffixe à ajouter au "Isy" en haut à gauche de l'écran
	appName = 'ocashe';

	// Titre de la page actuel, afficher dans la navbar à côter du bouton de menu
	currentPageTitle = 'Tableau de bord';

	optimNotifications: OptimNotification[];
	messagingNotifications: MessageNotification[];

	showRegionSelect = false;
	isIntervenant = false;
	oldUserExist = false;

	listService: Service[];
	service: Service;
	selectedService: number;

	listRegion: Region[];
	listAffectedRegion: Region[];
	selectedRegion: number;

	currentUser: User = null;
	currentEmployee: Employee = null;

	constructor(
		private modalService: BsModalService,
		private facade: FacadeService,
		private router: Router,
        private activeRoute: ActivatedRoute
	) {
		// if (this.facade.dataStorageService.isSSIAD()) {
		// 	this.appName = 'health';
		// }

		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				const url = event.url;
				if (url.includes('dashboard')) {
					this.currentPageTitle = 'Tableau de bord';
				} else if (url.includes('gestion')) {
					this.currentPageTitle = 'Administration';
				} else if (url.includes('parametrage')) {
					this.currentPageTitle = 'Paramétrage';
				} else if (url.includes('beneficiaire')) {
					this.currentPageTitle = 'Bénéficiaires';
				} else if (url.includes('planning')) {
					this.currentPageTitle = 'Gestion des plannings';
				} else if (url.includes('route')) {
					this.currentPageTitle = 'Gestion des tournées';
				} else if (url.includes('messagerie')) {
					this.currentPageTitle = 'Messagerie';
				} else if (url.includes('prestation')) {
					this.currentPageTitle = 'Prestations';
				} else if (url.includes('reports')) {
					this.currentPageTitle = 'Rapports';
				} else {
					this.currentPageTitle = 'Espace personnel';
				}
			}
		});
	}

	ngOnInit(): void {
		this.currentUser = this.facade.dataStorageService.getUser();
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();
		// this.facade.notificationService
		// 	.getNotifications(this.facade.dataStorageService.getUser()?.id)
		// 	.subscribe((notifications: Notification) => {
		// 		this.optimNotifications = notifications.optimNotifications;
		// 		this.messagingNotifications = notifications.messageNotifications;
		// 	});
		if(!this.isIntervenant){
			this.facade.regionService.getRegionsByUser(this.currentUser?.id).subscribe({
				next: (val) => {
					this.listAffectedRegion = val;
					this.listRegion = val;
					this.selectedRegion = this.facade.dataStorageService.getRegion()?.id;
				}
			});
			this.facade.serviceService.getServicesByUser(this.currentUser?.id).subscribe({
				next: (val) => {
					this.listService = val;
					this.selectedService = this.facade.dataStorageService.getService()?.id;

					this.service = this.listService.find(x => x.id == this.selectedService);
					if(this.service?.regions?.length > 1 && this.listAffectedRegion?.length > 1){
						this.showRegionSelect = true;
					}
				}
			});

			
		}

		if(this.facade.dataStorageService.getOldUser() != null){
			this.oldUserExist = true;
		}

		const previousUrl = history.state.prevPage ?? null;
		if (!previousUrl) {
			this.updatePageTitleAfterRefresh();
		}
	}

	updatePageTitleAfterRefresh() {
		const location = window.location.pathname;

		if (location.includes('dashboard')) {
			this.currentPageTitle = 'Tableau de bord';
		} else if (location.includes('gestion')) {
			this.currentPageTitle = 'Administration';
		} else if (location.includes('parametrage')) {
			this.currentPageTitle = 'Paramétrage';
		} else if (location.includes('beneficiaire')) {
			this.currentPageTitle = 'Bénéficiaires';
		} else if (location.includes('planning')) {
			this.currentPageTitle = 'Gestion des plannings';
		} else if (location.includes('route')) {
			this.currentPageTitle = 'Gestion des tournées';
		} else if (location.includes('messagerie')) {
			this.currentPageTitle = 'Messagerie';
		} else if (location.includes('reports')) {
			this.currentPageTitle = 'Rapports';
		} else {
			this.currentPageTitle = 'Espace personnel';
		}
	}

	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template);
	}

	goToDashboard(): void {
		this.router.navigate(['dashboard']);
	}

	signOut() {
		this.modalRef?.hide();
		this.clearStorage();
		//this.facade.authenticationService.logout()
	}

	onServiceChanged(serviceValue) { 
		this.service = this.listService.find(x => x.id == serviceValue.target.value);
		this.facade.dataStorageService.setService(this.service);
		this.facade.dataStorageService.setRegion(null);
		this.selectedService = serviceValue.target.value;
		if(this.service.regions?.length > 1){
			if(this.listAffectedRegion?.length > 1){
				this.showRegionSelect = true;
			}else{
				this.showRegionSelect = false;
			}
			this.listRegion = this.listAffectedRegion;
			this.selectedRegion = this.listAffectedRegion[0]?.id;
			this.facade.dataStorageService.setRegion(this.listAffectedRegion[0]);
		}else if (this.service.regions?.length == 1){
			this.showRegionSelect = false;
			this.selectedRegion = this.service.regions[0]?.id;
			this.facade.dataStorageService.setRegion(this.service.regions[0]);
		}
		this.reloadCurrentPage();
	}

	onRegionChanged(regionValue) { 
		this.facade.dataStorageService.setRegion(this.listRegion.find(x => x.id == regionValue.target.value));
		this.selectedRegion =regionValue.target.value;
		this.reloadCurrentPage();
	}

	/**
	 * Efface les éléments stockés en cache
	 */
	clearStorage() {
		//this.facade.notificationService.ngOnDestroy();
		this.facade.messageService.ngOnDestroy();
		this.facade.dataStorageService.clearStorage();
		location.reload();
	}

	reloadCurrentPage(){
		let currentUrl = this.router.url;
		this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
		this.router.navigate([currentUrl]);
		});
	}

	returnToMyAccount() : void{
		this.facade.dataStorageService.setUser(this.facade.dataStorageService.getOldUser());
		this.facade.dataStorageService.setOldUser(null);
		window.location.reload();
	}
}
